import { isGameBetOrder, isNotUpfrontOrder } from '../../lib/selectors/order';
import { getJsonItem } from '../../lib/session-storage/json';
import {
  challengeAcceptedUrl,
  createGameOrderUrl,
  membershipProfileUrl,
  startGameBetOrderUrl,
} from '../url-builders';
import { productUrlPrefix } from '../url-builders/url-utils';

const hasPartnerOffer = (order) =>
  order?.orderItems?.some((item) => item.showPartnerOffer == 'dailyBurn');

export const selectPostCompleteOrderUrl = ({
  game,
  isAdHocMembershipOrder,
  membershipReturnGame,
  order,
  theme,
  requiresRegistration = false,
}) => {
  const isQuizCartOrder = (order) =>
    getJsonItem('IS_NEW_TRIAL_FUNNEL_' + order?.id) === 'TRUE';

  const hasGame = !!game?.id && !!game?.type;
  const isFalkorGameOrder = game?.type == 'falkor' && !isAdHocMembershipOrder;

  if (isQuizCartOrder(order)) return '/membership-confirmation';

  if (isNotUpfrontOrder(order) && isFalkorGameOrder) {
    return startGameBetOrderUrl(game.id);
  }

  if (requiresRegistration) {
    return `${productUrlPrefix(theme)}/finish-registration`;
  }

  if (isAdHocMembershipOrder) {
    if (membershipReturnGame?.type) {
      return createGameOrderUrl({
        gameId: membershipReturnGame.id,
        product: membershipReturnGame.type,
      });
    }

    return membershipProfileUrl({ product: theme });
  }

  if (isFalkorGameOrder || isGameBetOrder(order)) {
    return challengeAcceptedUrl(game.id);
  }

  if (hasGame) {
    const params = new URLSearchParams();

    hasPartnerOffer(order) && params.append('orderId', order.id);

    return `/${game.type}/paybet-success/${game.id}?${params.toString()}`;
  }
};
